import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"
import isNaN from "lodash-es/isNaN"

import { axiosClient } from "$/http"

import { type IGroupSessionSummaryConfigDto } from "@/3514/types"
import { extractNumberFromQueryKeyPart } from "@/3514/utils"

import { ECoachGroupQueryKey as EKey, ECoachGroupSessionQueryUrl as EUrl } from "./coach.group.api.config"
import type {
    ICoachGroupSessionParticipantProgressDto as IIndividualDto,
    ICoachGroupSessionSummaryDto as ISummaryDto
} from "./coach.group.api.types"

async function individualProgressFetcher({
    queryKey
}: QueryFunctionContext<[string, string, string]>): Promise<IIndividualDto> {
    const { data }: AxiosResponse<IIndividualDto> = await axiosClient.get(
        EUrl.SessionIndividual({
            sessionId: extractNumberFromQueryKeyPart(queryKey[1]),
            individualId: extractNumberFromQueryKeyPart(queryKey[2])
        })
    )

    return data
}

async function summaryFetcher({ queryKey }: QueryFunctionContext<[string, string]>): Promise<ISummaryDto> {
    const { data }: AxiosResponse<ISummaryDto> = await axiosClient.get(
        EUrl.SessionSummary({ sessionId: extractNumberFromQueryKeyPart(queryKey[1]) })
    )

    return data
}

async function sessionSummaryConfigFetcher({
    queryKey
}: QueryFunctionContext<ReturnType<typeof EKey.SessionSummaryConfig>>): Promise<IGroupSessionSummaryConfigDto> {
    const sessionId: number = extractNumberFromQueryKeyPart(queryKey[1])

    if (isNaN(sessionId)) throw new Error("Session id should be a number.")

    const { data }: AxiosResponse<IGroupSessionSummaryConfigDto> = await axiosClient.get(
        EUrl.SessionSummaryConfig({ sessionId })
    )

    return data
}

export default {
    individualProgress: individualProgressFetcher,
    summary: summaryFetcher,
    sessionSummaryConfig: sessionSummaryConfigFetcher
}
